import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';

// import 'babel-polyfill'

import {
  Button, Input, Form, FormItem, Divider, Row, Col, Menu, MenuItem, Table, TableColumn, Message
} from 'element-ui'

Vue.config.productionTip = false

Vue.use(Button);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Divider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Table);
Vue.use(TableColumn);



Vue.prototype.$message = Message;


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
